import React from "react";
import { useForm } from "react-hook-form";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../utils/components/ui/dialog";
import { Button } from "../../utils/components/ui/button";
import { useQuotationPaid } from "../../service/quatationService";
import { toast } from "react-toastify";
import { useAddInvoice } from "../../service/invoiseService";
import { AxiosError } from "axios";
import { QueryClient, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

interface QuotationSaveModalProps {
  open: boolean;
  onCancel: () => void;
  onContinue: (data: { actualAmount: string; lpoNumber: string }) => void;
  quotationAmount: string;
  onClose: () => void; // new prop for handle close
  quoteData: any;
  setQuoteData?: (data: any) => void; // optional prop for setting quote data
}

export const QuotationSaveModal: React.FC<QuotationSaveModalProps> = ({
  open,
  onCancel,
  onContinue,
  quotationAmount,
  onClose,
  quoteData,
  setQuoteData,
}) => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  console.log(quoteData, "quoteData in QuotationSaveModal");

  const SaveInvoice = useAddInvoice({
    onSuccess: (data) => {
      console.log("Mutation response:", data);
      toast.success("Success");
      setQuoteData && setQuoteData(null);
      queryClient.invalidateQueries({ queryKey: ["useGetAllQuotation"] });
      onClose();
      reset();
    },
    onError: (error: Error) => {
      console.error("Error saving invoice:", error);
      toast.error(`Failed to save invoice: ${error.message}`);
    },
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();
  const PaidQuote = useQuotationPaid({
    onSuccess: (data) => {
      console.log("Mutation response:", data);
      navigate("/save-invoice?id=" + data.id);

      // const salesProductRequests = data?.quotationProducts.map((item: any) => ({
      //   id: item.id,
      //   productId: item.product.id,
      //   quantity: item.qty,
      //   unitPrice: item.unitPrice,
      //   discountAmount: item.discountAmount,
      //   taxPercentage: item.rateOfTax,
      // }));
      //   toast.success('Success');
      // SaveInvoice.mutate({
      //   id: data.id,
      //   paidAmount: Number(data.paidAmount),
      //   roundingAmount: Number(data.roundingAmount || 0),
      //   salesProductRequests
      // });
      //   setQuoteData && setQuoteData(null);
      //   onClose();
      //   reset();
    },
  });
  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open) onClose();
      }}
    >
      <DialogContent className="max-w-md w-full">
        <DialogHeader>
          <DialogTitle className="text-[#1A5EF9] text-2xl font-bold mb-2">
            Converted to invoice
          </DialogTitle>
          <div className="text-gray-600 text-base mb-6">
            Quotation amount:{" "}
            <span className="font-medium">
              {quoteData?.totalAmount?.toString() ?? "0"}
            </span>
          </div>
        </DialogHeader>
        <form
          onSubmit={handleSubmit((data) => {
            PaidQuote.mutate({
              quotationId: quoteData.id,
              paidAmount: Number(data.actualAmount),
              tRNNumber: data.lpoNumber,
            });
          })}
          className="space-y-4"
        >
          <input
            type="text"
            {...register("actualAmount", { required: true })}
            placeholder="Enter paid amount"
            className="w-full bg-[#F3F4F3] border-none rounded-md px-4 py-3 text-gray-700 placeholder-gray-400 focus:outline-none"
          />
          {errors.actualAmount && (
            <p className="text-red-500 text-xs">
              Actual quote amount is required
            </p>
          )}
          <input
            type="text"
            {...register("lpoNumber")}
            placeholder="Enter LPO number"
            className="w-full bg-[#F3F4F3] border-none rounded-md px-4 py-3 text-gray-700 placeholder-gray-400 focus:outline-none"
          />
          <DialogFooter className="flex flex-row gap-4 mt-6">
            <Button
              type="button"
              variant="outline"
              className="w-1/2 text-lg font-semibold"
              onClick={onCancel}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="w-1/2 bg-[#1A5EF9] text-white text-lg font-semibold hover:bg-[#1450D1]"
              disabled={PaidQuote.status === "pending"}
            >
              {PaidQuote.status === "pending" ? "Loading..." : "Continue"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default QuotationSaveModal;
